import { useOktaAuth } from '@okta/okta-react';
import { Button } from 'semantic-ui-react'; 
import { useLocation } from 'react-router-dom';

const OktaLogin = () => {

    const { oktaAuth } = useOktaAuth()
    const location = useLocation()

    const login = async () => {
        localStorage.setItem("callbackUrl", location.pathname)
        await oktaAuth.signInWithRedirect();
    }

    return (
        <Button size="small" onClick={login}>Log in with Okta</Button>
    )

}

export default OktaLogin